import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import "../styles/Login.css";

const ADMIN_LOGIN = gql`
  mutation AdminLogin($username: String!, $password: String!) {
    adminLogin(username: $username, password: $password) {
      success
      message
      token
      refreshToken
    }
  }
`;

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [adminLogin, { loading, error }] = useMutation(ADMIN_LOGIN);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const { data } = await adminLogin({
        variables: { username, password },
      });

      if (data.adminLogin.success) {
        localStorage.setItem("accessToken", data.adminLogin.token);
        localStorage.setItem("refreshToken", data.adminLogin.refreshToken);
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("currentUser", JSON.stringify({ username, role: "admin" }));
        navigate("/dashboard");
      } else {
        alert(data.adminLogin.message);
      }
    } catch (err) {
      alert("Login failed: " + err.message);
    }
  };

  return (
    <div className="login-dark">
      <div className="login-box">
        <img src="/flyhubicon.svg" alt="FlyHub Logo" className="flyhub-logo" />
        <p className="login-sub">Admin Access Portal</p>

        <form onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging In..." : "Log In"}
          </button>
          {error && <p style={{ color: "red" }}>{error.message}</p>}
        </form>

        <footer className="login-footer">
          <small>© 2025 Drone Admin. All rights reserved.</small>
        </footer>
      </div>

      <div className="orb orb1"></div>
      <div className="orb orb2"></div>
      <div className="orb orb3"></div>
    </div>
  );
}

export default Login;